import React from 'react'
import useCurrentUser from '../../hooks/use-current-user'
import AdminFooter from './admin'
import StudentFooter from './student'
import DefaultFooter from './default'
import RatingPrompt from './rating-prompt'

const DynamicFooter = () => {
    const { isBusy, isStudent, isTsc, isAuthorized, isVerified } = useCurrentUser()

    if (!isBusy && isAuthorized && isVerified) {
        if (isStudent || isTsc) {
            return (
                <React.Fragment>
                    <RatingPrompt />
                    <StudentFooter />
                </React.Fragment>
            )
        }
        return (<AdminFooter />)
    }

    return (<DefaultFooter />)
}

export default DynamicFooter